module.exports = __webpack_public_path__ + "img/logo-1.23298f9c.png";